import { getUser } from '@frontend/auth-helpers';
import { pendo } from '@frontend/tracking';
import { ONBOARDING_FLOW_TRACKING_IDS } from '../trackingIds/onboarding-flow-tracking-ids';

export const trackOnboardingFlow = (eventName: keyof typeof ONBOARDING_FLOW_TRACKING_IDS) => {
  const userId = getUser()?.userID || '';

  console.log('schedule onboarding flow event:', eventName);
  pendo.track(ONBOARDING_FLOW_TRACKING_IDS[eventName], {
    userId,
    timestamp: new Date().toISOString(),
  });
};
